import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { getTestId } from '../../../../utils/commonUtils';
import { BLUE_100, BLUE_500 } from '../../../../constants';
import { getFuseStyles } from '../../FuseStyles';
export var FuseStep = props => {
  var isCompleted = props.isCompleted,
    isCurrent = props.isCurrent,
    currentStepPercentage = props.currentStepPercentage,
    testID = props.testID,
    config = props.config;
  var activeColor = (config === null || config === void 0 ? void 0 : config.activeColor) || BLUE_500;
  var defaultColor = (config === null || config === void 0 ? void 0 : config.defaultColor) || BLUE_100;
  var fuseStyles = getFuseStyles();
  var backgroundColor = isCompleted || isCurrent ? activeColor : defaultColor;
  return _jsxs(View, Object.assign({
    style: fuseStyles.step
  }, getTestId(testID), {
    children: [_jsx(View, {
      style: [fuseStyles.stepBackground, {
        backgroundColor: defaultColor
      }]
    }), _jsx(View, Object.assign({
      style: [fuseStyles.stepFill, {
        backgroundColor,
        width: isCompleted ? '100%' : currentStepPercentage + "%"
      }]
    }, getTestId(testID, 'filled')))]
  }));
};